// src/components/ModalPreview.tsx
import React from "react";
import { Dialog } from "primereact/dialog";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

interface ModalPreviewProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  fileUrl: string;
}

export const ModalPreview: React.FC<ModalPreviewProps> = ({ visible, setVisible, fileUrl }) => {
  const extension = fileUrl?.split(".").pop()?.toLowerCase();
  const defaultLayoutPluginInstance = defaultLayoutPlugin();

  const renderContent = () => {
    if (!fileUrl) return null;

    if (extension === "pdf") {
      return (
        <div style={{ height: "80vh" }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.9.179/build/pdf.worker.min.js">
            <Viewer fileUrl={fileUrl} plugins={[defaultLayoutPluginInstance]} />
          </Worker>
        </div>
      );
    } else if (["doc","docx","xls","xlsx","ppt","pptx"].includes(extension)) {
      const officeViewer = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(fileUrl)}`;
      return <iframe src={officeViewer} style={{ width: "100%", height: "80vh" }} title="Office Preview" />;
    } else {
      return <p>Aperçu non disponible pour ce type de fichier</p>;
    }
  };

  return (
    <Dialog header="Aperçu du fichier" visible={visible} onHide={() => setVisible(false)} maximizable style={{ width: "80%" }}>
      {renderContent()}
    </Dialog>
  );
};